/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-18 15:06:16                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 15:06:26                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Interfaces
  * Color: Manage colors theme
    * getColor: get color with variant
    * getAllColors: get list of all colors
  * Singleton thing
*/

/* Imports */
import colors from "./colors.json";
/***/

/* Interfaces */
interface IColor {
  [key: string]: {
    [key: string]: string
  }
}
/***/

/**
* Color: Manage colors theme
*/
class Color {
  /**
  * getColor: get color with variant
  * @param name - color name
  * @param variant - color variant
  */
  public getColor(name: string, variant: string): string {
    return (colors as IColor)[name]?.[variant] ?? "grey";
  }
  /***/

  /**
  * getAllColors: get list of all colors
  */
  public getAllColors(): string[] {
    return Object.keys(colors);
  }
  /***/
}
/***/

/* Singleton thing */
const colorSignleton = () => {
  return new Color();
};

declare global {
  var color: undefined | ReturnType<typeof colorSignleton>;
}

export const color = globalThis.color ?? colorSignleton();
/***/
